/* AD-04 · DISPUTES & REASONED ACCESS
   ADM-11/12: queue, evidence, conditions, attempts, decision, customer
   outcome; scoped time-boxed access. · Bible §11 */
import { Button, ListRow, Note } from '@/ui'
import { useAdmin } from './AdminShell'
import Mark from './Mark'

export default function AD04Disputes() {
  const rows = useAdmin().disputes
  return (
    <section data-frame="AD-04" style={{ display: 'grid', gap: 14 }}>
      <h2 className="t-section">Litiges cadeaux &amp; accès support</h2>
      <div>
        {rows.map(r => (
          <ListRow key={r.title} title={r.title} meta={r.meta}
            end={<Mark cell={r.status} />} />
        ))}
      </div>
      <Note tone="candour">
        Accès support : motif obligatoire, périmètre limité (ce cadeau, cette étape), durée
        bornée, journalisé — jamais d’impersonation silencieuse. Décision → résultat client
        visible (ré-émission, maintien, geste marchand).
      </Note>
      <div style={{ display: 'flex', gap: 10 }}>
        <Button variant="quiet">Chronologie complète</Button>
        <Button variant="primary">Trancher</Button>
      </div>
    </section>
  )
}
